__turbopack_context__.v({
  "className": "perfectlynineties_d997044e-module__Owo3bG__className",
  "variable": "perfectlynineties_d997044e-module__Owo3bG__variable",
});
